import { useFlags } from 'launchdarkly-react-client-sdk'

import { FeatureFlags } from '.'

/** A simple wrapper around useFlags that returns our feature flags with the correct
 *  type information.
 **/
export function useFeatureFlags() {
  return useFlags<FeatureFlags>()
}
